// extracted by mini-css-extract-plugin
export default {"headRow":"AddQuickHeader_headRow__Pyenu","headCell":"AddQuickHeader_headCell__sgp0J"};